/**
 * @generated SignedSource<<13175d1a90403f00a85554e7ec1cdaf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RequestRestrictionBlockingScope = "FULL" | "PARTIAL";
export type RequestRestrictionType = "BLOCK" | "EVENT" | "RESTRICTION";
import { FragmentRefs } from "relay-runtime";
export type SavedRequestRow_booking$data = {
  readonly __typename: string;
  readonly id: string;
  readonly request?: {
    readonly maxTime: string;
    readonly minTime: string;
    readonly time: string;
  } | null | undefined;
  readonly requestRestrictionStatuses: ReadonlyArray<{
    readonly blockingScope: RequestRestrictionBlockingScope;
    readonly endAt: string;
    readonly label: string;
    readonly startAt: string;
    readonly type: RequestRestrictionType;
  }>;
  readonly startSlot: {
    readonly __typename: string;
    readonly agenda: {
      readonly date: string;
    };
    readonly time?: string;
  } | null | undefined;
  readonly " $fragmentType": "SavedRequestRow_booking";
};
export type SavedRequestRow_booking$key = {
  readonly " $data"?: SavedRequestRow_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"SavedRequestRow_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SavedRequestRow_booking",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "TimeSlot",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "BucketTimeSlot",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Request",
          "kind": "LinkedField",
          "name": "request",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxTime",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RequestRestrictionStatus",
      "kind": "LinkedField",
      "name": "requestRestrictionStatuses",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockingScope",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "0e25b97d1cab44fa851dc5cd4fb00893";

export default node;
